<template>
  <div v-if="!isMobile()">
    <navbar
      position="fixed"
      type="default"
      :transparent="transparent"
      :color-on-scroll="colorOnScroll"
      :paddingTop="paddingTop"
      menu-classes="ml-auto-test"
    >
      <template slot-scope="{ toggle, isToggled }">
        <router-link v-popover:popover1 class="logoWrap" to="/">
          <img v-lazy="'/img/renewal/logo.png'" width="100%"/>
        </router-link>
      </template>
      <template slot="navbar-menu">
        <!-- <li class="nav-item">
          <router-link
            class="nav-link"
            to="/"
          >
            <p>{{$t(`menu_home`)}}</p>
          </router-link>
        </li> -->
        <!-- <li class="nav-item">
            <router-link
              class="nav-link"
              to="/genesis"
            >
              <p>GENESIS</p>
            </router-link>
          </li> -->
        <ul class="navbar-1">
          <li class="nav-item">
            <a
              class=""
              href="//marketplace.leagueofkingdoms.com" target="_blank"
            >
              <p>MARKETPLACE</p>
            </a>
          </li>
          <li class="nav-item">
            <router-link
              class=""
              to="/land"
            >
              <p>{{$t(`menu_land`)}}</p>
            </router-link>
          </li>       
          <li class="nav-item">
            <router-link
              class=""
              to="/drago"
            >
              <!-- <p>{{$t(`menu_drago`)}}</p> -->
              <p>DRAGO</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class=""
              to="/pledging"
            >
              <p>PLEDGING</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class=""
              to="/breed"
            >
              <p>BREED</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class=""
              to="/lok"
            >
              <p>{{$t(`menu_arena`)}}</p>
            </router-link>
          </li>
          <li class="nav-item">
            <a
              class=""
              href="//leagueofkingdoms.zendesk.com/hc/en-us" target="_blank"
            >
              <p>SUPPORT</p>
            </a>
          </li>
        </ul>
        <!-- <li class="nav-item">
          <a
            class="nav-link"
            href="//medium.com/league-of-kingdoms-eng" target="_blank"
          >
            <p>{{$t(`menu_media`)}}</p>
          </a>
        </li> -->
        <!-- <drop-down
                tag="li"
                v-bind:title="$t($i18n.locale)"
                class="nav-item"
        >
          <div @click="$i18n.locale='en'" class="dropdown-item">
            English
          </div>
          <div @click="$i18n.locale='ko'" class="dropdown-item">
            한국어
          </div>
          <div @click="$i18n.locale='ch-zn'" class="dropdown-item">
            中文
          </div>
          <div @click="$i18n.locale='ja'" class="dropdown-item">
            日本語
          </div>
        </drop-down> -->
        <div class="navbar-2">
          <div class="navbar-right">
            <a href="https://twitter.com/LeagueKingdoms" target="_blank">
              <img v-lazy="'/img/renewal/icon-contact-x.png'" />
            </a>
            <a href="https://discord.gg/lokofficial" target="_blank">
              <img v-lazy="'/img/renewal/icon-contact-discord.png'" />
            </a>
            <a href="https://medium.com/league-of-kingdoms-eng" target="_blank">
              <img v-lazy="'/img/renewal/icon-contact-midium.png'" />
            </a>
            <a href="https://leagueofkingdoms.substack.com/" target="_blank">
              <img v-lazy="'/img/renewal/icon-contact-substack.png'" />
            </a>
            <a href="https://www.facebook.com/LofK.Official" target="_blank">
              <img v-lazy="'/img/renewal/icon-contact-facebook.png'" />
            </a>
            <!-- <a href="#" @click="openModal('subscribe')">
              <img v-lazy="'/img/icon_contact_subscribe.png'" />
            </a> -->
          </div>
          <ul class="navbar-right">
            <li class="nav-item" v-if="myAccount == null">
              <div
                class="Connect-Wallet-btn"
                @click="goConnectWallet()"
              >
              Connect Wallet
              </div>
            </li>
            <li class="nav-item" v-if="myAccount != null">
              <div id="account-menu" v-if="menu" style="position:absolute;background-color:rgba(255,255,255,1);color:#284473;vertical-align:middle;font-size: 14px;
      font-weight: bold;text-align:left;line-height:36px;padding:10px;width:100px;height:auto;margin-top:50px;margin-left:0px;width:208px;border-radius:10px;">
              <div @click="goMyItem()" style="cursor: pointer; background:10px no-repeat url('/img/icon_wallet_item.png');padding-left:50px;">My Item</div>
              <div @click="goMyDrago()" style="cursor: pointer; background:10px no-repeat url('/img/icon-mydrago.png');padding-left:50px;">My Drago</div>
              <div @click="goBridge()" style="cursor: pointer; background:10px no-repeat url('/img/icon_bridge.png');padding-left:50px;">Bridge</div>
              <div @click="goMyReward()" style="cursor: pointer; background:10px no-repeat url('/img/icon-reward.png');padding-left:50px;">My Reward</div>
              <div @click="goDisconnectWallet()" style="cursor: pointer; background:10px no-repeat url('/img/icon_wallet_disconnect.png');padding-left:50px;">Disconnect Wallet</div>
              </div>
              <div
                style="cursor: pointer; background-image: url('/img/btn_wallet.png'); background-size: 100% 100%; width: 170px; height: 40px; margin-left: 30px; display:flex; align-items:flex-start; "
                @click="menu=!menu"
              >
                <img v-if="isEth()" src="/img/login_eth.png" style="margin-left: 20px; " />
                <img v-if="isPolygon()" src="/img/login_matic.png" style="margin-left: 20px;" />
              <p v-if="isEth() || isPolygon()"  style="color: #000; margin: 8px 0 0; font-size: 16px;">{{$t(showAddress(myAccount.address))}}</p>
              <p v-else  style="color: #000; padding-left: 48px; padding-top: 9px; font-size: 16px;">{{$t(showAddress(myAccount.address))}}</p>
              </div>
            </li>
          </ul>
        </div>
        <!-- <li class="nav-item">
          <div
            style="cursor: pointer; background-image: url('/img/event/btn_event.png'); background-size: 100% 100%; width: 42px; height: 46px; margin-left: 10px;"
            @click="goEvent()"
          >
          </div>
        </li> -->
      </template>
    </navbar>
  </div>
  <div v-else>
    <navbar
      position="fixed"
      type="default"
      :transparent="transparent"
      :color-on-scroll="colorOnScroll"
      :paddingTop="paddingTop"
      menu-classes="ml-auto mobile"
    >
      <template slot-scope="{ toggle, isToggled }">
        <router-link v-popover:popover1 class="navbar-brand" to="/">
          <img v-lazy="'/img/renewal/logo.png'" width="100%"/>
        </router-link>
      </template>
      <template slot="navbar-menu">
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/"
          >
            <p>{{$t(`menu_home`)}}</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/land"
          >
            <p>{{$t(`menu_land`)}}</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/drago"
          >
            <p>{{$t(`menu_drago`)}}</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/lok"
          >
            <p>{{$t(`menu_arena`)}}</p>
          </router-link>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="//medium.com/league-of-kingdoms-eng" target="_blank"
          >
            <p>{{$t(`menu_media`)}}</p>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="//leagueofkingdoms.zendesk.com/hc/en-us" target="_blank"
          >
            <p>SUPPORT</p>
          </a>
        </li>
        <!-- <drop-down
                tag="li"
                v-bind:title="$t($i18n.locale)"
                class="nav-item"
        >
          <div @click="$i18n.locale='en'" class="dropdown-item">
            English
          </div>
          <div @click="$i18n.locale='ko'" class="dropdown-item">
            한국어
          </div>
          <div @click="$i18n.locale='ch-zn'" class="dropdown-item">
            中文
          </div>
          <div @click="$i18n.locale='ja'" class="dropdown-item">
            日本語
          </div>
        </drop-down> -->
        <li class="nav-item" style="position: absolute; bottom: 80px; left: 20px;">
          <a href="https://twitter.com/LeagueKingdoms" target="_blank">
            <img v-lazy="'/img/icon_contact_twitter.png'" height="35px" />
          </a>
          <a href="https://www.facebook.com/LofK.Official" target="_blank">
            <img v-lazy="'/img/icon_contact_facebook.png'" height="35px" />
          </a>        
          <a href="https://medium.com/league-of-kingdoms-eng" target="_blank">
            <img v-lazy="'/img/icon_contact_midium.png'" height="35px" />
          </a>
          <a href="https://discord.gg/lokofficial" target="_blank">
            <img v-lazy="'/img/icon_contact_discord.png'" height="35px" />
          </a>
          <!-- <a href="#" @click="openModal('subscribe')">
            <img v-lazy="'/img/icon_contact_subscribe.png'" height="35px" />
          </a> -->
        </li>
        <!-- <li class="nav-item">
          <div
            style="cursor: pointer; background-image: url('/img/event/btn_event.png'); background-size: 100% 100%; width: 42px; height: 46px; margin-left: 10px;"
            @click="goEvent()"
          >
          </div>
        </li> -->
      </template>
    </navbar>
  </div>
</template>

<script>
import { DropDown, Button, NavbarToggleButton, Navbar, NavLink } from '@/components';
import {connectWallet, disconnectWallet} from '../utils/wallet';
import { Popover } from 'element-ui';
import config from '../config';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
    paddingTop: Boolean,

  },
  data(){
    return {
      menu: false
    };
  },
  mounted() {
    connectWallet(this.$store);
  },
  methods: {
    openModal: function(modalName) {
      this.$store.commit(`openModal`, modalName);
    },
    goEvent() {
      let url = "//land.leagueofkingdoms.com/event" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goMedia() {
      let url = "//medium.com/league-of-kingdoms-eng" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goMarketPlace() {
      let url = "//marketplace.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goSupport() {
      let url = "//leagueofkingdoms.zendesk.com/hc/en-us" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goMyItem() {
      this.menu = false;
      if(this.$router.history.current.name!="/myItem");
        this.$router.push("/myitem");
    },
    goMyDrago() {
      this.menu = false;
      if(this.$router.history.current.name!="/myDrago");
        this.$router.push("/myDrago");
    },
    goBridge() {
      this.menu = false;
      if(this.$router.history.current.name!="/bridge");
        this.$router.push("/bridge");
    },
    goMyReward() {
      this.menu = false;
      if(this.$router.history.current.name!="/myReward");
        this.$router.push("/myReward");
    },
    isEth() {
      return this.$store.state.account.networkId == config.network.eth;
    },
    isPolygon() {
      return this.$store.state.account.networkId == config.network.polygon;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    goConnectWallet() {
      this.openModal('wallet');
    },
    goDisconnectWallet() {
      this.menu = false;
      disconnectWallet(this.$store);
    },
    showAddress(address) {
      return address.substring(0, 5) + "..." + address.substring(address.length - 3);
    },
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Button.name]: Button,
    [Popover.name]: Popover
  },
  computed: {
    myAccount() {
      if (this.$store.state.account.wallet == null) {
        return null;
      }
      return this.$store.state.account.wallet;
    },    
  },
};
</script>

<style scoped></style>
